import React, { useState, useEffect } from 'react';
import './HeroV2.css';
import RichText from '../RichText';
import { trackContactClick } from '../../utils/analytics';

const HeroV2 = ({ content, whatsappLink }) => {
  const [deviceType, setDeviceType] = useState(() => {
    if (typeof window === 'undefined') return 'desktop';
    const width = window.innerWidth;
    if (width < 768) return 'mobile';
    return width <= 1024 ? 'tablet' : 'desktop';
  });

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDeviceType('mobile');
      } else if (width <= 1024) {
        setDeviceType('tablet');
      } else {
        setDeviceType('desktop');
      }
    };
    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  const rawEyebrow = content?.eyebrow || 'AI POWERED BUSINESS TRANSFORMATION';
  const cleanEyebrow = rawEyebrow.replace(/[-–—]/g, ' ').replace(/\s+/g, ' ').trim();

  const heroData = {
    eyebrow: cleanEyebrow,
    titleLine1: content?.titleLine1 || 'AI Development Company for',
    titleLine2: content?.titleLine2 || 'Enterprise AI & Automation',
    description: content?.description || 'Venus Global Technology helps enterprises design, build and deploy production-ready AI systems — from AI agents and intelligent automation to custom AI software, enterprise integrations and digital transformation across the USA and Canada.',
    ctaButton: content?.ctaButton || 'Talk to an Enterprise AI Expert',
    secondaryCtaButton: content?.secondaryCtaButton || 'View AI Case Studies',
    secondaryCtaLink: content?.secondaryCtaLink || '/blogs'
  };

  const handlePrimaryClick = () => {
    const targetLink = whatsappLink || 'https://wa.me/16477616277';
    trackContactClick({
      type: 'whatsapp',
      destination: targetLink,
      label: heroData.ctaButton || 'Talk to an Enterprise AI Expert'
    });
    window.open(targetLink, '_blank');
  };

  const handleSecondaryClick = () => {
    window.location.href = heroData.secondaryCtaLink;
  };
  return (
    <section 
      className={`v2-hero-chatbot hero-device-${deviceType}`}
    >
      <div className="v2-hero-chatbot-container">
        {/* Left Content Side */}
        <div className="v2-hero-chatbot-left">
          {/* Eyebrow Tag */}
          <div className="v2-hero-eyebrow">
            <span className="v2-hero-eyebrow-text">{heroData.eyebrow}</span>
          </div>

          {/* Main Heading */}
          <h1 className="v2-hero-chatbot-title">
            <span className="v2-hero-title-main">{heroData.titleLine1}</span>
            <span className="v2-hero-title-highlight">{heroData.titleLine2}</span>
          </h1>

          {/* Supporting Paragraph */}
          <div className="v2-hero-chatbot-supporting">
            <RichText html={heroData.description} as="p" />
          </div>

          {/* CTA Action Buttons */}
          <div className="v2-hero-chatbot-cta">
            {/* Primary Blue Gradient Pill Button */}
            <button className="v2-hero-btn-pill" onClick={handlePrimaryClick}>
              <span className="v2-hero-btn-text">{heroData.ctaButton}</span>
              <span className="v2-hero-btn-arrow-circle">
                <i className="fas fa-arrow-right"></i>
              </span>
            </button>

            {/* Secondary Glass Play Button */}
            {heroData.secondaryCtaButton && (
              <button className="v2-hero-btn-play" onClick={handleSecondaryClick}>
                <span className="v2-hero-btn-play-circle">
                  <i className="fas fa-play"></i>
                </span>
                <span className="v2-hero-btn-play-text">{heroData.secondaryCtaButton}</span>
              </button>
            )}
          </div>
        </div>

        {/* Right side spacer to keep 50% width clear for the background visual on desktop */}
        <div className="v2-hero-chatbot-spacer"></div>
      </div>
    </section>
  );
};

export default HeroV2;
